import { Footer } from '../types';
import { escapeHtml } from '../utils/security';

export function buildFooter(footer: Footer) {
    const root = document.querySelector('[data-section="footer"]');
    if (!root) return;

    root.innerHTML = `
        <div class="max-w-page mx-auto flex flex-col items-center gap-6 text-center">
            <img src="/assets/logo-horisontal-mork.svg" alt="Maeland Code Craft" class="h-8 w-auto opacity-90" />
            <nav class="flex gap-6 flex-wrap justify-center" aria-label="Bunnmeny">
                <a href="#om" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Om meg</a>
                <a href="#erfaring" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Erfaring</a>
                <a href="#utdanning" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Utdanning</a>
                <a href="#sertifiseringer" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Sertifiseringer</a>
                <a href="#ferdigheter" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Ferdigheter</a>
                <a href="#prosjekter" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Prosjekter</a>
                <a href="#kontakt" class="font-mono text-[11px] tracking-[1.5px] uppercase text-n300 hover:text-creme transition-colors">Kontakt</a>
            </nav>
            <div class="w-full h-px bg-creme/10"></div>
            <div class="text-sm text-n400">&copy; ${new Date().getFullYear()} ${escapeHtml(footer.owner)}. Alle rettigheter reservert.</div>
            <div class="font-mono text-xs text-n500">${escapeHtml(footer.note)}</div>
        </div>
    `;
}
